// extracted by mini-css-extract-plugin
export var iconLink = "ExternalLink-module--iconLink--19Y9Y";
export var fadeIn = "ExternalLink-module--fadeIn--G9i5N";
export var slideIn = "ExternalLink-module--slideIn--PVvnZ";
export var bgGradient = "ExternalLink-module--bgGradient--OAHDK";
export var borderColorStep = "ExternalLink-module--borderColorStep--3F2Nq";